import React from 'react';
export const useCheckMidKeyPress = () => {
    const isMidKeyPress = React.useRef(false);
    const onKeyDown = (e) => {
        if (e.key === 'Tab' || e.key === 'Escape')
            return;
        isMidKeyPress.current = true;
    };
    const onKeyUp = () => {
        isMidKeyPress.current = false;
    };
    const onBlur = () => {
        isMidKeyPress.current = false;
    };
    return React.useMemo(() => ({
        elementProps: {
            onKeyDown,
            onKeyUp,
            onBlur,
        },
        isMidKeyPress,
    }), []);
};
